jQuery( document ).ready(function() {
    
    jQuery('.navigation').find('li.menu-item-has-children').each(function(){
        if(jQuery(this).find('.current_page_item').length){
            jQuery(this).addClass('open'); 
        }
        var toogle = jQuery('<span class="toggle"></span>')
        jQuery(toogle).on('click',function(){
           jQuery(this).parent().toggleClass('open');
        });
        jQuery(this).append(toogle);
    });
    
    if(jQuery('.sidebar .navigation li').length == 0){
        jQuery('.sidebar .title').hide();
    }
    
});